// src/notify.js

function getWin() {
    return typeof window !== 'undefined' ? window : undefined;
  }
  function getNav() {
    return typeof navigator !== 'undefined' ? navigator : undefined;
  }
  function getNotificationCtor() {
    const w = getWin();
    return w && 'Notification' in w ? w.Notification : null;
  }
  
  export function canUseNotifications() {
    return !!getNotificationCtor();
  }
  
  export function isIOSStandalone() {
    const w = getWin();
    const n = getNav();
    if (!w || !n) return false;
  
    const ua = String((n && n.userAgent) || '');
    const isiOS = /iPad|iPhone|iPod/.test(ua);
  
    const hasMatchMediaStandalone =
      !!(w && w.matchMedia && w.matchMedia('(display-mode: standalone)').matches);
    const hasLegacyStandalone = !!(n && n.standalone);
  
    const standalone = hasMatchMediaStandalone || hasLegacyStandalone;
    return isiOS && standalone;
  }
  
  export async function requestNotifyPermission() {
    const N = getNotificationCtor();
    if (!N) return 'denied';
    try {
      if (N.permission === 'granted' || N.permission === 'denied') return N.permission;
      const p = await N.requestPermission();
      return p;
    } catch {
      return 'denied';
    }
  }
  
  export async function tryNotify(title, options) {
    const w = getWin();
    const n = getNav();
    const N = getNotificationCtor();
  
    const fallback = () => {
      try {
        const msg = options && options.body ? `${title}\n${options.body}` : title;
        if (w && typeof w.alert === 'function') w.alert(msg);
      } catch {}
    };
  
    // No Notification API at all (e.g., iOS Safari non-PWA)
    if (!N) {
      fallback();
      return false;
    }
  
    const ua = String((n && n.userAgent) || '');
    const isiOS = /iPad|iPhone|iPod/.test(ua);
  
    const hasMatchMediaStandalone =
      !!(w && w.matchMedia && w.matchMedia('(display-mode: standalone)').matches);
    const hasLegacyStandalone = !!(n && n.standalone);
    const standalone = hasMatchMediaStandalone || hasLegacyStandalone;
  
    // iOS only exposes Notifications for installed PWAs (iOS 16.4+).
    if (isiOS && !standalone) {
      fallback();
      return false;
    }
  
    try {
      if (N.permission === 'granted') {
        new N(title, options);
        return true;
      }
      if (N.permission !== 'denied') {
        const p = await N.requestPermission();
        if (p === 'granted') {
          new N(title, options);
          return true;
        }
      }
    } catch {}
  
    fallback();
    return false;
  }
  